import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Dialog,
    Button,
    Avatar,
} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import ReduxGlobal from "../store/actionreducers/globalView";

class UecareLoadingMask extends Component {

    state = {
        open: false,
        setTimeoutFunc: null,
        refreshButtonDisplay: 'none',
    };

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.setTimeoutFunc) clearTimeout(this.setTimeoutFunc);
        if (!prevProps.loadingMask.props.open && this.props.loadingMask.props.open) {
            this.setState({refreshButtonDisplay: 'none'});
            this.setTimeoutFunc = setTimeout(() => {
                this.setState({refreshButtonDisplay: ''});
            }, 3000);
        }
    }

    _getImageUrl = () => {
        return (this.props.loadingMask.is_success) ?
            'https://res.cloudinary.com/uecare/image/upload/v1538638013/service/check.gif' :
            'https://res.cloudinary.com/uecare/image/upload/v1537438268/service/Spinner-1s-200px.gif';
    };

    refresh = () => {
        window.location.reload();
    };

    render() {

        const {loadingMask} = this.props;

        return (
            <div>
                <Dialog
                    {...(loadingMask && loadingMask.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <Avatar className="w-96 h-96" alt="contact avatar"
                            src={this._getImageUrl()}/>
                    <Button variant="contained"
                            color='primary'
                            style={{display: this.state.refreshButtonDisplay}}
                            onClick={this.refresh}>
                        刷新頁面
                    </Button>
                </Dialog>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {loadingMask}}) {
    return {loadingMask};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UecareLoadingMask));



// WEBPACK FOOTER //
// ./src/components/UecareLoadingMask.js